import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import { isUndefined } from "../../../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import AssetLibrary from "../../../../core/assetloading/AssetLibrary";
import AbstractMediator from "../../../../core/ui/AbstractMediator";
import DisplayObjectUtil from "../../../util/DisplayObjectUtil";

export default class TutorialHubMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {LanguagePack} languagePack
     * @param {AssetLibrary} assetLibrary
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, assetLibrary) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._assetLibrary = assetLibrary;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();
        this._target.HubScreenSkin.TimingBG.ChapterLabel.text = this._languagePack.getText('tutorial.hub.HubChapter');
        this._target.HubScreenSkin.TimingBG.WeekLabel.text = this._languagePack.getText('tutorial.hub.HubWeek');
        this._target.HubScreenSkin.timerKeyDecision.textField.text = this._languagePack.getText('tutorial.hub.HubTimer');
        this._updateTextButton(this._target.HubScreenSkin.dashboardButton, "", 'tutorial.hub.HubDashboard', false);
        this._updateTextButton(this._target.HubScreenSkin.teaCorner, "", 'tutorial.hub.HubTeaCorner', false);
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder1, "name", 'tutorial.hub.HubColleague1Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder1, "position", 'tutorial.hub.HubColleague1Title');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder2, "name", 'tutorial.hub.HubColleague2Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder2, "position", 'tutorial.hub.HubColleague2Title');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder3, "name", 'tutorial.hub.HubColleague3Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder3, "position", 'tutorial.hub.HubColleague3Title');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder4, "name", 'tutorial.hub.HubColleague4Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder4, "position", 'tutorial.hub.HubColleague4Title');

        this._updateBackgroundImage('MainAssets_Translated_MapTutorial');
    }
    
    _updateBackgroundImage(imageId) {
        this._target.HubScreenSkin.bg.visible = false;
        for (let child of this._target.HubScreenSkin.children) {
            if (!isUndefined(child.image)) {
                child.visible = false;
            }
        }
        const image = this._assetLibrary.tryGetBitmapFromImageId(imageId);

        // Manual correction since for some reason the screen sits a little to the right
        image.setTransform(image.x - 8);
        
        DisplayObjectUtil.anchorDisplayObject(image, Anchor.C);
        this._target.HubScreenSkin.addChild(image);

        // sort items on top of background (needed since we're not using an imageContainer)
        this._target.HubScreenSkin.sortChildren(function(obj1, obj2, options) {
            if (isUndefined(obj1.image) && isUndefined(obj2.image)) { return 0; }
            if (!isUndefined(obj1.image) && !isUndefined(obj2.image)) { return 0; }
            if (!isUndefined(obj1.image) && isUndefined(obj2.image)) { return -1; }
            if (isUndefined(obj1.image) && !isUndefined(obj2.image)) { return 1; }
            return 0;
        });
        console.log();
    }

    _updateTextButton(target, prefix, languageKey, capitalizeButtonState = true) {
        var buttonStates = ["upLabelTextField", "overLabelTextField", "disabledLabelTextField", "downLabelTextField"];
        buttonStates.forEach((buttonState) => {
            var updateButtonState = buttonState;
            if(capitalizeButtonState) {
                updateButtonState = updateButtonState.charAt(0).toUpperCase()+ updateButtonState.slice(1);
            }
            target[prefix + updateButtonState].text = this._languagePack.getText(languageKey);
        });
    }
}